// This file is used to generate a list of radius options 25, 50, 75, etc...
export const STEP = 25
export const RADII = new Array(9).fill(STEP).map((v, i) => v * i)
export const RADIUS_OPTIONS = RADII.map(miles => ({ label: miles.toString(), value: miles }))
export const DEFAULT_RADIUS = STEP
export const RADIUS_RANGES = RADII.slice(1).map((max, id) => ({
  id,
  min: max - STEP,
  max,
}))
